import { API_CALL } from 'actions/actionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import { FETCH_LOYALTY_CONFIG } from 'actions/apiActionConstants'
import requestLoyaltyConfig from 'api/loyalty/requestLoyaltyConfig'

function fetchLoyaltyConfig(): AppAction {
  return (dispatch, getState) => {
    const state = getState()
    const region = state.geo.currentRegionCode

    if (state.loyalty.fetchingConfig || state.loyalty.config?.region === region) {
      return
    }

    if (state.loyalty.configError && state.loyalty.configErrorRegion === region) {
      return
    }

    dispatch({
      type: API_CALL,
      api: FETCH_LOYALTY_CONFIG,
      region,
      request: () => requestLoyaltyConfig(region),
    })
  }
}

export default fetchLoyaltyConfig
